[
    [
        "Warszawa",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        65830
    ],
    [
        "Warszawa",
        "Liczba miejsc kubaturowych",
        2024,
        537
    ],
    [
        "Warszawa",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        66246
    ],
    [
        "Warszawa",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        2096
    ],
    [
        "Warszawa",
        "Suma zebranych opłat za postój",
        2024,
        266645000
    ],
    [
        "Warszawa",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        411784
    ],
    [
        "Warszawa",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        61733000
    ],
    [
        "Gdańsk",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        8878
    ],
    [
        "Gdańsk",
        "Liczba miejsc kubaturowych",
        2024,
        378
    ],
    [
        "Gdańsk",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        7764
    ],
    [
        "Gdańsk",
        "Łączny wpływ z abonamentów",
        2024,
        1303460
    ],
    [
        "Gdańsk",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        2362
    ],
    [
        "Gdańsk",
        "Suma zebranych opłat za postój",
        2024,
        32237677.29
    ],
    [
        "Gdańsk",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        69758
    ],
    [
        "Gdańsk",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        9470812.57
    ],
    [
        "Kraków",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        20800
    ],
    [
        "Kraków",
        "Liczba miejsc kubaturowych",
        2024,
        335
    ],
    [
        "Kraków",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        41719
    ],
    [
        "Kraków",
        "Liczba sprzedanych abonamentów dniowych",
        2024,
        1322
    ],
    [
        "Kraków",
        "Liczba sprzedanych abonamentów miesięcznych",
        2024,
        9568
    ],
    [
        "Kraków",
        "Łączny wpływ z abonamentów",
        2024,
        10438270.49
    ],
    [
        "Kraków",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        893
    ],
    [
        "Kraków",
        "Suma zebranych opłat za postój",
        2024,
        110703348.93
    ],
    [
        "Kraków",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        121032
    ],
    [
        "Kraków",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        14659950.82
    ],
    [
        "Wrocław",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        9369
    ],
    [
        "Wrocław",
        "Liczba miejsc kubaturowych",
        2024,
        984
    ],
    [
        "Wrocław",
        "Łączny wpływ z abonamentów",
        2024,
        2802943.74
    ],
    [
        "Wrocław",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        2669
    ],
    [
        "Wrocław",
        "Suma zebranych opłat za postój",
        2024,
        40449409.92
    ],
    [
        "Wrocław",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        74948
    ],
    [
        "Wrocław",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        10173467.64
    ],
    [
        "Poznań",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        14670
    ],
    [
        "Poznań",
        "Liczba miejsc kubaturowych",
        2024,
        0
    ],
    [
        "Poznań",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        18890
    ],
    [
        "Poznań",
        "Łączny wpływ z abonamentów",
        2024,
        4357630
    ],
    [
        "Poznań",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        1421
    ],
    [
        "Poznań",
        "Suma zebranych opłat za postój",
        2024,
        73078610.83
    ],
    [
        "Poznań",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        84471
    ],
    [
        "Poznań",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        18583620,
        true
    ],
    [
        "Szczecin",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        12000
    ],
    [
        "Szczecin",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        109624
    ],
    [
        "Szczecin",
        "Liczba sprzedanych abonamentów dniowych",
        2024,
        65814
    ],
    [
        "Szczecin",
        "Liczba sprzedanych abonamentów miesięcznych",
        2024,
        30839
    ],
    [
        "Szczecin",
        "Liczba sprzedanych abonamentów półrocznych",
        2024,
        3931
    ],
    [
        "Szczecin",
        "Liczba sprzedanych abonamentów rocznych",
        2024,
        3020
    ],
    [
        "Szczecin",
        "Łączny wpływ z abonamentów",
        2024,
        9595120
    ],
    [
        "Szczecin",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        1273
    ],
    [
        "Szczecin",
        "Suma zebranych opłat za postój",
        2024,
        33098108.39
    ],
    [
        "Szczecin",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        106765
    ],
    [
        "Szczecin",
        "Łączna liczba pobranych opłat za złamanie regulaminu parkowania",
        2024,
        36309
    ],
    [
        "Szczecin",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        3883894.69
    ],
    [
        "Bydgoszcz",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        4257
    ],
    [
        "Bydgoszcz",
        "Liczba miejsc kubaturowych",
        2024,
        285
    ],
    [
        "Bydgoszcz",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        13236
    ],
    [
        "Bydgoszcz",
        "Liczba sprzedanych abonamentów miesięcznych",
        2024,
        10173
    ],
    [
        "Bydgoszcz",
        "Liczba sprzedanych abonamentów kwartalnych",
        2024,
        2197
    ],
    [
        "Bydgoszcz",
        "Liczba sprzedanych abonamentów półrocznych",
        2024,
        567
    ],
    [
        "Bydgoszcz",
        "Liczba sprzedanych abonamentów rocznych",
        2024,
        299
    ],
    [
        "Bydgoszcz",
        "Łączny wpływ z abonamentów",
        2024,
        877295
    ],
    [
        "Bydgoszcz",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        541
    ],
    [
        "Bydgoszcz",
        "Suma zebranych opłat za postój",
        2024,
        9023068.36
    ],
    [
        "Bydgoszcz",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        17544
    ],
    [
        "Bydgoszcz",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        1660952.56
    ],
    [
        "Katowice",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        9057
    ],
    [
        "Katowice",
        "Liczba miejsc kubaturowych",
        2024,
        0
    ],
    [
        "Katowice",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        22896
    ],
    [
        "Katowice",
        "Łączny wpływ z abonamentów",
        2024,
        2300000
    ],
    [
        "Katowice",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        0
    ],
    [
        "Katowice",
        "Suma zebranych opłat za postój",
        2024,
        28600000
    ],
    [
        "Katowice",
        "Łączna liczba pobranych opłat za złamanie regulaminu parkowania",
        2024,
        14400
    ],
    [
        "Katowice",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        1900000
    ],
    [
        "Białystok",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        3700
    ],
    [
        "Białystok",
        "Liczba miejsc kubaturowych",
        2024,
        0
    ],
    [
        "Białystok",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        2267
    ],
    [
        "Białystok",
        "Liczba sprzedanych abonamentów miesięcznych",
        2024,
        472
    ],
    [
        "Białystok",
        "Liczba sprzedanych abonamentów kwartalnych",
        2024,
        256
    ],
    [
        "Białystok",
        "Liczba sprzedanych abonamentów półrocznych",
        2024,
        303
    ],
    [
        "Białystok",
        "Liczba sprzedanych abonamentów rocznych",
        2024,
        1236
    ],
    [
        "Białystok",
        "Łączny wpływ z abonamentów",
        2024,
        981833
    ],
    [
        "Białystok",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        0
    ],
    [
        "Białystok",
        "Suma zebranych opłat za postój",
        2024,
        12197042.53
    ],
    [
        "Białystok",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        17412
    ],
    [
        "Białystok",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        1300318.27
    ],
    [
        "Opole",
        "Liczba miejsc kubaturowych",
        2024,
        343
    ],
    [
        "Opole",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        2600
    ],
    [
        "Opole",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        0
    ],
    [
        "Opole",
        "Koszt opłaty dodatkowej za złamanie regulaminu parkowania",
        2024,
        120
    ],
    [
        "Opole",
        "Suma zebranych opłat za postój",
        2024,
        8442277
    ],
    [
        "Opole",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        29350
    ],
    [
        "Opole",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        1761000,
        true
    ],
    [
        "Kielce",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        2000
    ],
    [
        "Kielce",
        "Liczba miejsc kubaturowych",
        2024,
        0
    ],
    [
        "Kielce",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        2318
    ],
    [
        "Kielce",
        "Liczba sprzedanych abonamentów dniowych",
        2024,
        182
    ],
    [
        "Kielce",
        "Łączny wpływ z abonamentów",
        2024,
        833680
    ],
    [
        "Kielce",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        2341
    ],
    [
        "Kielce",
        "Suma zebranych opłat za postój",
        2024,
        3446787.10
    ],
    [
        "Kielce",
        "Łączna liczba wystawionych wezwań do zapłaty za złamanie regulaminu parkowania",
        2024,
        13801
    ],
    [
        "Kielce",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        1914100
    ],
    [
        "Lublin",
        "Liczba wyznaczonych miejsc postojowych",
        2024,
        2740
    ],
    [
        "Lublin",
        "Liczba miejsc kubaturowych",
        2024,
        0
    ],
    [
        "Lublin",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        4912
    ],
    [
        "Lublin",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        12
    ],
    [
        "Toruń",
        "Liczba sprzedanych abonamentów w sumie",
        2024,
        4646
    ],
    [
        "Toruń",
        "Łączny wpływ z abonamentów",
        2024,
        398584
    ],
    [
        "Toruń",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2024,
        70
    ],
    [
        "Toruń",
        "Suma zebranych opłat za postój",
        2024,
        9701640
    ],
    [
        "Toruń",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2024,
        892790.15
    ],
    [
        "Łódź",
        "Liczba wyznaczonych miejsc postojowych",
        2023,
        7273960
    ],
    [
        "Łódź",
        "Liczba miejsc kubaturowych",
        2023,
        0
    ],
    [
        "Łódź",
        "Liczba sprzedanych abonamentów w sumie",
        2023,
        4184
    ],
    [
        "Łódź",
        "Liczba sprzedanych abonamentów miesięcznych",
        2023,
        31
    ],
    [
        "Łódź",
        "Liczba sprzedanych abonamentów kwartalnych",
        2023,
        130
    ],
    [
        "Łódź",
        "Liczba sprzedanych abonamentów rocznych",
        2023,
        203
    ],
    [
        "Łódź",
        "Łączny wpływ z abonamentów",
        2023,
        1518030
    ],
    [
        "Łódź",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2023,
        4801
    ],
    [
        "Łódź",
        "Koszt opłaty dodatkowej za złamanie regulaminu parkowania",
        2023,
        200
    ],
    [
        "Łódź",
        "Suma zebranych opłat za postój",
        2023,
        17677567
    ],
    [
        "Łódź",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2023,
        5692492
    ],
    [
        "Rzeszów",
        "Liczba wyznaczonych miejsc postojowych",
        2023,
        3491
    ],
    [
        "Rzeszów",
        "Liczba miejsc kubaturowych",
        2023,
        510
    ],
    [
        "Rzeszów",
        "Liczba sprzedanych abonamentów w sumie",
        2023,
        37464
    ],
    [
        "Rzeszów",
        "Łączny wpływ z abonamentów",
        2023,
        938585
    ],
    [
        "Rzeszów",
        "Liczba wydanych uprawnień do parkowania bez opłat",
        2023,
        0
    ],
    [
        "Rzeszów",
        "Koszt opłaty dodatkowej za złamanie regulaminu parkowania",
        2023,
        200
    ],
    [
        "Rzeszów",
        "Suma zebranych opłat za postój",
        2023,
        10565545.29
    ],
    [
        "Rzeszów",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2023,
        687627
    ],
    [
        "Gorzów",
        "Liczba wyznaczonych miejsc postojowych",
        2023,
        1170
    ],
    [
        "Gorzów",
        "Liczba miejsc kubaturowych",
        2023,
        0
    ],
    [
        "Gorzów",
        "Liczba sprzedanych abonamentów w sumie",
        2023,
        1034
    ],
    [
        "Gorzów",
        "Liczba sprzedanych abonamentów miesięcznych",
        2023,
        641
    ],
    [
        "Gorzów",
        "Liczba sprzedanych abonamentów rocznych",
        2023,
        372
    ],
    [
        "Gorzów",
        "Łączny wpływ z abonamentów",
        2023,
        263800
    ],
    [
        "Gorzów",
        "Koszt opłaty dodatkowej za złamanie regulaminu parkowania",
        2023,
        200
    ],
    [
        "Gorzów",
        "Suma zebranych opłat za postój",
        2023,
        2942511.17
    ],
    [
        "Gorzów",
        "Łączna liczba pobranych opłat za złamanie regulaminu parkowania",
        2023,
        1090
    ],
    [
        "Gorzów",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2023,
        54500
    ],
    [
        "Olsztyn",
        "Liczba wyznaczonych miejsc postojowych",
        2023,
        2400
    ],
    [
        "Olsztyn",
        "Liczba miejsc kubaturowych",
        2023,
        0
    ],
    [
        "Olsztyn",
        "Liczba sprzedanych abonamentów w sumie",
        2023,
        1178
    ],
    [
        "Olsztyn",
        "Liczba sprzedanych abonamentów miesięcznych",
        2023,
        316
    ],
    [
        "Olsztyn",
        "Liczba sprzedanych abonamentów półrocznych",
        2023,
        862
    ],
    [
        "Olsztyn",
        "Łączny wpływ z abonamentów",
        2023,
        938500
    ],
    [
        "Olsztyn",
        "Koszt opłaty dodatkowej za złamanie regulaminu parkowania",
        2023,
        150
    ],
    [
        "Olsztyn",
        "Suma zebranych opłat za postój",
        2023,
        5775082
    ],
    [
        "Olsztyn",
        "Łączna liczba pobranych opłat za złamanie regulaminu parkowania",
        2023,
        2426
    ],
    [
        "Olsztyn",
        "Łączna kwota pobranych opłat za złamanie regulaminu parkowania",
        2023,
        130324
    ]
]